export const zh = {
  common: {
    siteTitle: "继母与继姐",
    siteSubtitle: "重组家庭关系指南",
    navHome: "首页",
    navCategories: "文章分类",
    navAbout: "关于我们",
    navContact: "联系我们",
    readMore: "阅读全文",
    backToList: "返回列表",
    relatedArticles: "相关文章",
    shareArticle: "分享文章",
    viewAll: "查看全部",
    breadcrumbHome: "首页",
    footerCopyright: "© 2026 继母与继姐关系指南. 保留所有权利.",
    footerTagline: "帮助重组家庭找到平衡与和谐",
    scrollToTop: "回到顶部",
  },
  home: {
    heroTitle: "继母与继姐",
    heroSubtitle: "在复杂的家庭关系中，找到属于你的平衡与温暖",
    heroDescription: "深度解析重组家庭中继母与继姐的角色定位、情感边界与和谐相处策略，帮助你在复杂关系中找到真实的连接。",
    featuredTitle: "精选文章",
    categoriesTitle: "探索分类",
    faqTitle: "常见问题",
    faqSubtitle: "关于重组家庭关系，你可能想知道的一切",
    subscribeTitle: "获取每周家庭关系指南",
    subscribeSubtitle: "订阅我们的通讯，每周收到实用的家庭关系建议和温暖的故事",
    subscribePlaceholder: "输入你的邮箱地址",
    subscribeButton: "免费订阅",
  },
  category: {
    title: "文章分类",
    allArticles: "全部文章",
  },
  article: {
    authorPrefix: "作者",
    readTime: "阅读时间",
    publishedDate: "发布日期",
  },
  about: {
    title: "关于我们",
    brandTitle: "品牌故事",
    brandDescription: "我们是一群关注重组家庭关系的心理咨询师、教育工作者和亲历者。我们深知重组家庭的复杂与美丽，致力于为每一个在家庭关系中努力的人提供专业、温暖的指导。",
    reputationTitle: "专业口碑",
    contactTitle: "联系我们",
    contactDescription: "有任何关于重组家庭关系的问题或建议？我们很乐意倾听你的故事。",
  },
};